import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { Heading, IconWithText } from '@spotahome/ui-library';

import './HowItWorks.scss';

const HowItWorks = () => (
  <div className="wrapper">
    <Heading
      size="large"
      text={trans('ambassador.looking_for_you.hiw.title')}
      className="mb-xl"
    />

    <div className="three-cols">
      <div className="how-it-works-item">
        <IconWithText
          title={trans('ambassador.hiw.first.item.title')}
          content={trans('ambassador.hiw.first.item.content')}
          iconUrl={getResourcePath('/images/icons/speech.svg')}
          theme="dark"
          contentFontStyle="normal"
        />
      </div>
      <div className="how-it-works_item">
        <IconWithText
          title={trans('ambassador.hiw.second.item.title')}
          content={trans('ambassador.hiw.second.item.content')}
          iconUrl={getResourcePath('/images/icons/megaphone.svg')}
          theme="dark"
          contentFontStyle="normal"
        />
      </div>
      <div className="how-it-works_item">
        <IconWithText
          title={trans('ambassador.hiw.third.item.title')}
          content={trans('ambassador.hiw.third.item.content')}
          iconUrl={getResourcePath('/images/icons/coins.svg')}
          theme="dark"
          contentFontStyle="normal"
        />
      </div>
    </div>
  </div>
);

export default HowItWorks;
